import { Card } from '@/components/ui/card';
import { PageFrame } from '@/components/ui/page-frame';

export function ProjectDetailSkeleton() {
  return (
    <PageFrame layout="content" className="select-none">
      {/* Header Skeleton */}
      <div className="sticky top-0 z-lureo-layer-bar surface-bar">
        <div className="container py-4">
          <div className="flex items-center justify-between">
            <div className="flex min-w-0 items-center gap-1">
              <div className="h-9 w-9 animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
              <div className="h-6 w-px bg-lureo-line" />
              <div className="ml-2 h-8 w-48 animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
              <div className="ml-2 h-6 w-16 animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
            </div>
            <div className="hidden items-center gap-3 lg:flex">
              <div className="h-8 w-20 animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
              <div className="h-8 w-16 animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
              <div className="h-9 w-32 animate-pulse rounded-lureo-radius-pill bg-lureo-surface/20" />
            </div>
          </div>
        </div>
      </div>

      <div className="container py-6 md:py-8">
        {/* Project Overview Skeleton */}
        <div className="mb-6 grid grid-cols-1 gap-6 md:mb-8 md:gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            {/* The same heights as the overview it stands in for: a 288px cover, the numbers 24px under it */}
            <Card className="overflow-hidden">
              <div className="h-72 w-full animate-pulse rounded-lureo-radius-lg bg-lureo-surface/20" />
              <div className="grid grid-cols-2 gap-4 px-6 pt-6 md:grid-cols-4">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="flex flex-col items-center gap-1">
                    <div className="h-8 w-12 animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
                    <div className="h-4 w-16 animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
                  </div>
                ))}
              </div>
            </Card>
          </div>
          {/* Location and timeline: two cards and their gap filling the cover card's height */}
          <div className="flex flex-col gap-4 md:gap-6">
            {[24, 20].map((title, i) => (
              <Card key={i} className="flex-1">
                <div className={`mb-4 h-7 animate-pulse rounded-lureo-radius bg-lureo-surface/20 ${title === 24 ? 'w-28' : 'w-24'}`} />
                <div className="flex flex-col gap-3">
                  <div className="h-10 w-3/4 animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
                  <div className="h-10 w-1/2 animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Tabs Skeleton */}
        <div className="space-y-6">
          <div className="grid h-auto w-full grid-cols-4 gap-1 p-1 bg-lureo-surface/20 rounded-lureo-radius">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="h-16 animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
            ))}
          </div>
          <div className="space-y-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-32 w-full animate-pulse rounded-lureo-radius bg-lureo-surface/20" />
            ))}
          </div>
        </div>
      </div>
    </PageFrame>
  );
}
